import { useLingui } from "@lingui/react";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AppDialog } from "@/components/common/AppDialog";

interface ChangeToDraftDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export function ChangeToDraftDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending = false,
}: ChangeToDraftDialogProps) {
  const { i18n } = useLingui();

  return (
    <AppDialog open={open} onOpenChange={onOpenChange} hideClose size="sm">
      <div className="flex flex-col items-center gap-4 py-4 text-center">
        <div className="flex size-20 items-center justify-center rounded-lg bg-(--color-surface-chip-inactive)">
          <FileText className="size-10" />
        </div>

        <h3 className="text-lg font-semibold">
          {i18n._("Change status to Draft?")}
        </h3>
        <p className="text-sm text-(--color-text-secondary)">
          {i18n._(
            "This item will be moved back to Draft and unpublished. It will no longer be active or visible until republished.",
          )}
        </p>

        <div className="flex w-full gap-3 pt-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => onOpenChange(false)}
          >
            {i18n._("Cancel")}
          </Button>
          <Button className="flex-1" onClick={onConfirm} disabled={isPending}>
            {i18n._("Change to Draft")}
          </Button>
        </div>
      </div>
    </AppDialog>
  );
}
